export default "__VITE_ASSET__EjNOfMDw__"